import { render, staticRenderFns } from "./self.vue?vue&type=template&id=cc0f5e1c&scoped=true"
import script from "./self.vue?vue&type=script&lang=js"
export * from "./self.vue?vue&type=script&lang=js"
import style0 from "./self.vue?vue&type=style&index=0&id=cc0f5e1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0f5e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc0f5e1c')) {
      api.createRecord('cc0f5e1c', component.options)
    } else {
      api.reload('cc0f5e1c', component.options)
    }
    module.hot.accept("./self.vue?vue&type=template&id=cc0f5e1c&scoped=true", function () {
      api.rerender('cc0f5e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/self.vue"
export default component.exports